import { declension } from "../lib";
import Form from "../components/base/forms/form";
import Dropdown from "../components/base/dropdown";
import Api from "../lib/api";
import {AnalyticsService} from "../services/analytics-service";

export default class Footer {
	constructor() {
		this.$root = document.querySelector('.site-footer');

		if (craft.env.dynamicFooter) {
			this.initDynamic();
		} else if (this.$root) {
			this.init();
		}
	}

	initDynamic() {
		const $siteInner = document.querySelector('.site-inner');
		const params = {
			city: Api.currentCityId,
			page: craft.page.handle,
			theme: craft.env.footerTheme,
			site: craft.env.siteName
		};

		if (craft.page.handle === 'certificate') {
			const segments = craft.env.urlSegments;

			if (segments[0] === 'view' && segments[1]) {
				params.certificate = segments[1];
			}
		}

		if (this.urlRu && this.urlUk) {
			params.urlRu = this.urlRu;
			params.urlUk = this.urlUk;
		}

		Api.get(`${craft.env.apiSiteUrl}/feed/dynamicFooter`, params)
			.then((data) => {
				if (data) {
					$siteInner.insertAdjacentHTML('afterend', data);
					this.init();
				}
			});
	}

	init() {
		this.addSiteSwitcherListener();
		this.declineSubscribersWord();

		if (!document.getElementById('form-mailing')) return;

		this.mailingForm = new Form({
			formId: 'mailing',
			uri: '/2.0/subscribe/footer',
			data: {
				city: craft.env.cityId,
				referrer: location.href
			},
			animation: { enabled: false },
			subscriptions: [{
				event: 'beforeSubmit',
				callback: () => {
					const dataLayerEventData = {
						event: 'subscription_footer_form',
						formId: this.mailingForm.formId,
						email: this.mailingForm.data.email
					};

					const $formTitle = this.mailingForm.$root.querySelector('.form_title');

					if ($formTitle) {
						dataLayerEventData.formName = $formTitle.textContent;
					}

					AnalyticsService.sendEvent('subscription_footer_form', dataLayerEventData);

					/* Adds name data if defined in local storage */
					let storage = localStorage.getItem('formValues');

					if (!storage) return;

					storage = JSON.parse(storage);

					if (!storage.name) return;

					this.mailingForm.addData({
						name: storage.name
					})
				}
			}]
		});
	}

	addSiteSwitcherListener() {
		const $dropdownMenu = document.querySelector('[data-dropdown-menu="footer"]');
		const $dropdownTrigger = document.querySelector('[data-dropdown-trigger="footer"]');

		if (!$dropdownMenu || !$dropdownTrigger) return;

		const dropdown = new Dropdown($dropdownMenu, $dropdownTrigger);
	}

	declineSubscribersWord() {
		const $subscribers = document.querySelector('.social-subscribers');
		const $declensionSubscribers = $subscribers.querySelector('.social-subscribers_declension');

		const subscribersCount = $subscribers.querySelector('.social-subscribers_count').textContent;
		const wordVariations = craft.localization.subscribers;

		$declensionSubscribers.textContent = ' ' + declension(+subscribersCount, wordVariations).toLowerCase();
	}
}